"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-207acd6d"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = { class: "message-video" };
var _hoisted_2 = ["src"];
var _hoisted_3 = ["src", "poster"];
var _hoisted_4 = ["src", "poster"];
var _hoisted_5 = {
    key: 3,
    class: "progress"
};
var _hoisted_6 = ["value"];
var _hoisted_7 = ["src"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_1, [
        vue_1.createElementVNode("div", {
            class: vue_1.normalizeClass(["message-video-box", [
                    !_ctx.data.progress && _ctx.data.message.status === 'success' && _ctx.isH5 && 'message-video-cover',
                ]]),
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return (_ctx.toggleShow && _ctx.toggleShow.apply(_ctx, args));
                }),
            ref: "skeleton"
        }, [
            ((_ctx.data.progress && _ctx.poster) || (_ctx.isH5 && _ctx.poster))
                ? (vue_1.openBlock(), vue_1.createElementBlock("img", {
                    key: 0,
                    class: vue_1.normalizeClass(["message-img", [_ctx.isWidth ? 'isWidth' : 'isHeight']]),
                    src: _ctx.poster
                }, null, 10, _hoisted_2))
                : (_ctx.isH5)
                    ? (vue_1.openBlock(), vue_1.createElementBlock("video", {
                        key: 1,
                        class: "message-img video-h5-uploading",
                        src: _ctx.data.url + '#t=0.1',
                        poster: _ctx.data.url,
                        preload: "auto",
                        muted: "",
                        ref: "video"
                    }, null, 8, _hoisted_3))
                    : (!_ctx.data.progress && !_ctx.isH5)
                        ? (vue_1.openBlock(), vue_1.createElementBlock("video", {
                            key: 2,
                            class: "message-img video-web",
                            src: _ctx.data.url,
                            controls: "",
                            preload: "metadata",
                            poster: _ctx.poster,
                            ref: "video"
                        }, null, 8, _hoisted_4))
                        : vue_1.createCommentVNode("", true),
            (_ctx.data.progress)
                ? (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_5, [
                    vue_1.createElementVNode("progress", {
                        value: _ctx.data.progress,
                        max: "1"
                    }, null, 8, _hoisted_6)
                ]))
                : vue_1.createCommentVNode("", true)
        ], 2),
        (_ctx.show && _ctx.isH5)
            ? (vue_1.openBlock(), vue_1.createElementBlock("div", {
                key: 0,
                class: "dialog-video",
                onClick: _cache[3] || (_cache[3] = vue_1.withModifiers(
                //@ts-ignore
                function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return (_ctx.toggleShow && _ctx.toggleShow.apply(_ctx, args));
                }, ["self"]))
            }, [
                vue_1.createElementVNode("header", null, [
                    vue_1.createElementVNode("i", {
                        class: "icon icon-close",
                        onClick: _cache[1] || (_cache[1] = vue_1.withModifiers(
                        //@ts-ignore
                        function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            return (_ctx.toggleShow && _ctx.toggleShow.apply(_ctx, args));
                        }, ["stop"]))
                    })
                ]),
                vue_1.createElementVNode("div", {
                    class: vue_1.normalizeClass(["dialog-video-box", [_ctx.isH5 ? 'dialog-video-h5' : '']]),
                    onClick: _cache[2] || (_cache[2] = vue_1.withModifiers(
                    //@ts-ignore
                    function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return (_ctx.toggleShow && _ctx.toggleShow.apply(_ctx, args));
                    }, ["self"]))
                }, [
                    vue_1.createElementVNode("video", {
                        class: vue_1.normalizeClass([_ctx.isWidth ? 'isWidth' : 'isHeight']),
                        src: _ctx.data.url,
                        controls: "",
                        autoplay: ""
                    }, null, 10, _hoisted_7)
                ], 2)
            ]))
            : vue_1.createCommentVNode("", true)
    ]));
}
exports.render = render;
